import axios from 'axios';
import moment from 'moment';
import thaiFormat from '../lib/thaiFormat'
function delimeter(data) {
  let y = parseFloat(data).toFixed(2)
  let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return x

}
Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};
// var m = [
//   {
//     con_id: "",
//     descript: "ค่ากำจัดขยะ น้ำหนัก 0 - 30 กิโลกรัม",
//     start_w: 1,
//     end_w: 30,
//     price: 700,
//   },
//   {
//     con_id: "",
//     descript: "ค่ากำจัดขยะ น้ำหนัก 31 - 50 กิโลกรัม",
//     start_w: 31,
//     end_w: 50,
//     price: 1000,
//   },
//   {
//     con_id: "",
//     descript: "ค่ากำจัดขยะ น้ำหนัก 51 - 75 กิโลกรัม",
//     start_w: 51,
//     end_w: 75,
//     price: 1500,
//   },
// ]
// var arr = []
// var temp = []
// arr.unshift([{text: 'คำอธิบาย', style: 'tableHeader'}, {text: 'น้ำหนักเริ่มต้น', style: 'tableHeader'}, {text: 'จนถึงน้ำหนัก', style: 'tableHeader'},{text: 'ราคา/บาท', style: 'tableHeader'}])
// for(var i=0;i<m.length;i++){
// temp[0] = {text: m[i].DETAIL }
// temp[1] = {text: m[i].WEIGHT_MIN }
// temp[2] = {text: m[i].WEIGHT_MAX }
// temp[3] = {text: m[i].PRICE }
// arr.push(temp)
// tem = []

// }
// console.log(arr)

const receipt_2 = async function (data, product) {
  let body = data
  let isvat = ` (อัตราค่าบริการ ไม่รวมภาษีมูลค่าเพิ่ม) `
  if(body.ISVAT==1){
    isvat = ` (รวมVAT 7 %) `
  }
  const pdf = {
    //pageSize: 'A4',
    // pageMargins: [ 30, 0, 30, 0 ],
    footer(currentPage, pageCount) {
      return {
        columns: [
          // { text: "ท้ายกระดาษ", fontSize: 15, alignment: "center" },
          {
            text:
              "หน้าที่ " +
              currentPage.toString() +
              " จาก " +
              pageCount +
              " หน้า",
            margin: [5, 5, 15, 5],
            alignment: "right"
          }
        ]
      };
    },
    content: [
        {
            image: await getBase64ImageFromURL(
              "https://res.cloudinary.com/dfgnhewbg/image/upload/v1595224134/newchok-icon_tuzsem.png"
            ),
            alignment: "center",
            width: 70
          },
          {
            text: `สัญญาเลขที่ : \t\t ${body.CONTRACT_ID} \t\t`,
            fontSize: 16,
            alignment: "right",
            margin: [0, 0, 30, 10]
          }, //left top right bottom
          {
            text: `สัญญาจ้างการจัดเก็บและกำจัดขยะมูลอยติดเชื้อ`,
            style: `header`
          },
          {
            text: `สัญญานี้ทำขึ้น ณ\t${body.CUSTOMER_NAME}\tเมื่อวันที่\tเมื่อวันที่  ${moment(body.CONTRACT_START_DATE).locale("th").add(543, "Y").format("LL")}\t กับ ${this.$AppName.limited_company} โดย นายรัชพล กิตติคุณ ผู้มีอำนาจลงนามผูกพัน ตั้งอยู่ 389/40 หมู่ 2 ตำบลสันผีสือ อำเภอเมือง จังหวัดชียงใหม่ 50300 ในสัญญานี้เรียกว่า "ผู้รับจ้าง" ฝ่ายหนึ่งซึ่งประกอบกิจการสถานพยาบาลในนาม \n \t${body.CUSTOMER_NAME}\tโดย\t${body.PROVIDER_NAME}\t ผู้มีอำนาจลงนามผูกพัน สำนักงานตั้งอยู่ ที่\t ${body.CUSTOMER_ADDRESS} ${body.CUSTOMER_SUBDISTRICT} ${body.CUSTOMER_DISTRICT} ${body.CUSTOMER_PROVINCE} ${body.CUSTOMER_ZIPCODE} \tซึ่งต่อไปในสัญญนี้เรียกว่า "ผู้ว่าจ้าง" อีกฝ่ายหนึ่งทั้งสองฝ่ายได้ทำสัญญาโดยมีรายละเอียดดังนี้`,
            style: `content`
          },
          {
            text: `1.) "ผู้ว่าจ้าง" ตกลงอนุญาตให้ "ผู้รับจ้าง" ทำการเก็บ ขน กำจัดมูลฝอยติดเชื้อที่เกิดขึ้นภายใน สถานพยาบาลตาม\n ข้อกำหนดของพระราชบัญญัติการสาธารณสุข พ.ศ.2535 และกฎกระทรวงว่าด้วยการกำจัดมูลฝอยติดเชื้อ พ.ศ.2545`,
            style: `content`
          },
          {
            text: `2.) สัญญาฉบับนี้มีกำหนดระยะเวลา 1 ปีตั้งแต่วันที่\t${moment(body.CONTRACT_START_DATE).locale("th").add(543, "Y").format("LL")}\tถึงวันที่\t${moment(body.CONTRACT_END_DATE).locale("th").add(543, "Y").subtract(1, "days").format("LL")}\t`,
            style: `content`
          },
          {
            text: `3.) "ผู้รับจ้าง" จัดเก็บค่าธรรมเนียมเก็บขนและกำจัดมูลฝอยติดเชื้อจาก "ผู้ว่าจ้าง" ในอัตราเหมาจ่ายรายเดือน\nรายละเอียดดังนี้ `,
            style: `content`
          },
          {
              style: 'tableExample',
              table: {
                  headerRows: 1,
                  // dontBreakRows: true,
                  // keepWithHeaderRows: 1,
                  widths: [270, 70, 70, 70],
                  body: [
                      [{text: 'คำอธิบาย', style: 'tableHeader'}, {text: 'น้ำหนักเริ่มต้น', style: 'tableHeader'}, {text: 'จนถึงน้ำหนัก', style: 'tableHeader'},{text: 'ราคา/บาท', style: 'tableHeader'}],
                      [{text: 'ค่ากำจัดขยะ น้ำหนัก 0-30 กิโลกรัม', style: 'tableContent'}, {text: '0', style: 'tableContent'}, {text: '30', style: 'tableContent'},{text: '700.00', style: 'tableContent'}],
                      [{text: 'ค่ากำจัดขยะ น้ำหนัก 31-50 กิโลกรัม', style: 'tableContent'}, {text: '31', style: 'tableContent'}, {text: '50', style: 'tableContent'},{text: '1,000.00', style: 'tableContent'}],
                      [{text: 'ค่ากำจัดขยะ น้ำหนัก 51-75 กิโลกรัม', style: 'tableContent'}, {text: '51', style: 'tableContent'}, {text: '75', style: 'tableContent'},{text: '1,500.00', style: 'tableContent'}]
                  ]
              }
          },
          'ถ้าน้ำหนักกินโลกรัมที่ 76 เป็นต้นไปคิดกิโลกรัมละ 25 บาท และจัดเก็บต่าธรรมเนียมการเก็บขนมูลฝอยติดเชื้อปีละ 500.00 บาท (อัตราค่าบริการ ไม่รวมภาษีมูลค่าเพิ่ม)',
          {
            text: `4.) "ผู้รับจ้าง" มารับทำการเก็บ ขน มูลฝอยติดเชื้อ ณ จุดที่ทาง "ผู้ว่าจ้าง" กำหนดการเก็บขนสัปดาห์ละ 1 ครั้ง\nรอบเก็บ วัน ......... ช่วงเวลา 09.00 น. ถึง 16.00 น. โดยไม่มีมูลฝอยติดเชื้อตกค้าง มูลฝอยติดเชื้อที่จัดเก็บทุกครั้งจะนำไป \nรวบรวมไว้ที่จุดพักมูลฝอยติดเชื้อ ณ ที่ตั้งเตาเผา ในสุสานสันติธรรม ตำบลช้างเผือก อำเภอเมือง จังหวัดเชียงใหม่และนำไป \nกำจัดโดยบริษัทโชติฐกรณ์พิบูลย์ จำกัด ตั้งอยู่ 15/1 หมู่ 1 ตำบลหนองกรด อำเภอเมืองนครสวรรค์ จังหวัดนครสวรรค์`,
            style: `content`
          },
          {
            text: `5.) การเก็บมูลฝอยติดเชื้อทุกครั้ง "ผู้ว่าจ้าง" มีหน้าที่จัดเตรียมมูลฝอยติดเชื้อให้เรียบร้อยและคัดแยกชัดเจน พร้อม\nจัดเก็บได้ทันทีและทำการชั่งน้ำหนัก และลงบันทึกน้ำหนักโดยมี "ผู้ว่าจ้าง" และ "ผู้รับจ้าง" เซ็นรับทราบร่วมกันและถือว่า\nจำนวนน้ำหนักที่ลงบันทึกถูกต้องครบถ้วนทุกประการ ในกรณีผู้รับจ้างเข้าเก็บขนมูลฝอยติดเชื้อตามที่ผู้ว่าจ้างกำหนด แต่ไม่มีมูลฝอยติดเชื้อให้ลงบันทึกจำนวนถือว่า "ผู้ว่าจ้าง" ได้เก็บขนตามสัญญาฉบับนี้`,
            style: `content`
          },
          {
            text: `6.) ห้ามมิให้ "ผู้ว่าจ้าง" ทิ้งเข็มฉีดยา หรือวัตถุมีคมประเภทต่างๆลงในถุงมูลฝอยติดเชื้อ(ถุงแดง)โดยตรง ควรรวบรวม \nทิ้งไว้ในภาชนะที่แข็งแรงหรือถังเข็มที่ได้รับมาตรฐานเปิดฝาให้มิดชิด หากเกิดอันตรายต่อผู้ปฏิบัติงานทาง "ผู้ว่าจ้าง" จะต้องชดใช้รักษาพยาบาลแก่เจ้าหน้าที่ผู้ปฎิบัติงานหรือยกเลิกเก็บขนมูลฝอยติดเชื้อทันที`,
            style: `content`
          },
          {
            text: `7.) "ผู้รับจ้าง" และ "ผู้ว่าจ้าง" เข้าใจตรงกันในกรณีรอบเก็บ ขนมูลฝอยติดเชื้อตรงกับวันหยุดนักขัตฤกษ์ ผู้รับจ้าง\nจะเลื่อนไปเก็บ ขนมูลฝอยติดเชื้อในรอบต่อไปโดยไม่ต้องแจ้งให้กับผู้ว่าจ้างทราบล่วงหน้า`,
            style: `content`
          },
          {
            text: `8.) การบอกเลิกสัญญา`,
            style: `content`
          },
          {
            text: `8.1) กรณีการเก็บขนและกำจัดมูลฝอยติดเชื้อไม่เป็นตามข้อกำหนด "ผู้ว่าจ้าง" สามารถบอกกล่าวให้ปฏิบัติตามสัญญา\n โดยแจ้งเจ้าหน้าที่ที่ปฏิบัติงานรับทราบด้วยวาจาทันที หรือ หนังสือเป็นลายลักษณ์อักษรให้ทราบ เพื่อให้ปฏิบัติให้\nถูกต้องต่อไป`,
            style: `content_8`
          },
          {
            text: `8.2) กรณีเหตุการณ์ตามข้อที่ 8.1 จะต้องเกิดขึ้นโดยเฉลี่ยมากกว่า 3 ครั้ง/เดือน และเป็นเหตุการณ์ที่กระทบรุนแรง\nและผิดต่อกฎกระทรวงที่เกี่ยข้องอย่งชัดเจน ทางผู้ว่าจ้่าง สามารถบอกเลิกสัญญาได้ก่อนกำหนด\nและผู้ว่าจ้างสามารถเรียกรับค่าธรรมนียมการกำจัดมูลฝอยติดเชื้อ(ถ้ามี)ตามส่วนที่คงเหลือเท่านั้น`,
            style: `content_8`
          },
          {
            text: `8.3) ในการขอยกเลิกสัญญาจ้าง เก็บ ขน และกำจัดมูลฝอยติดเชื้อสามารถทำได้ต้องแจ้งให้กับ ผู้รับจำงที่เป็น\nคู่สัญญา รับทราบไม่น้อยกว่า 2 เดือนหรือ 60 วันทั้งนี้จะต้องมีการเก็บ ขนและกำจัดมูลฝอยติดเชื้ออย่างน้อย 6 เดือนไปแล้วหรือหยุดกิจการ ผู้รับจ้างขอสงวนสิทธิในการคืนค่าธรรมนียม(ถ้ามี)ที่ทำไว้กับ ผู้รับจ้าง ทุกกรณี`,
            style: `content_8`
          },
          {
            text: `8.4) ในกรณี ผู้ว่าจ้าง โยกย้ายกิจการไปยังอีกที่หนึ่ง และได้มีการปลี่ยนชื่อสถานพยาบาลจากเดิมในสัญญาให้ถือว่า สัญญาฉบับนี้ได้สิ้นสุดลงทันที`,
            style: `content_8`
          },
          {
            text: `9.)  การต่อสัญญา "ผู้ว่าจ้าง" สามารถแจ้งต่อสัญญาเมื่อครบกำหนด หรือ สัญญาครบกำหนดแล้วยังไม่มีการติดต่อจาก "ผู้ว่าจ้าง" ภายใน 30 วันให้เสมือนหนึ่งสัญญาฉบับดังกล่าวได้ต่อสัญญาโดยอัตโนมัติอีกคราวละ 1 ปี\nสัญญานี้จัดทำขึ้นสองฉบับ มีข้อความตรงกัน คู่สัญญาได้อ่านและเข้าใจตรงกันตามเจตนารมณ์แล้ว จึงลงลายมือชื่อไว้เป็นหลักฐานต่อหน้าพยาน`,
            style: `content`
          },
          {
            text: `ลงชื่อ ........................................................................ ผู้ว่าจ้าง\n( ................................................................ )\n......................................................................`,
            style: `signature`
          },
          {
            text: `ลงชื่อ ........................................................................ พยาน\n( ................................................................ )\n......................................................................`,
            style: `signature`
          },
          {
            text: `ลงชื่อ ........................................................................ ผู้รับจ้าง\n( นายรัชพล กิตติคุณ )\n${this.$AppName.limited_company}`,
            style: `signature`
          },
          {
            text: `ลงชื่อ ........................................................................ พยาน\n( นายธีรพัชญ์ จิโนเป็ง )\n${this.$AppName.limited_company}`,
            style: `signature`
          }
    ],
    defaultStyle: {
      font: "THSarabunNew"
    },
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 16,
        color: 'black'
      },
      tableContent: {
        fontSize: 16,
      },
      header: {
        fontSize: 16,
        alignment: "center"
        //bold: true
      },
      header1: {
        fontSize: 16,
        alignment: "center",
        bold: true
      },
      header2: {
        fontSize: 16,
        alignment: "center",
        bold: true
      },
      tableExample: {
        alignment: "center",
        margin: [0, 5, 0, 15]
      },



      content: {
        fontSize: 16,
        alignment: "left",
        margin: [0, 10, 0, 0]
      },
      content_1: {
        bold: true,
        fontSize: 14,
        color: 'black',
        alignment: "left",
        margin: [0, 10, 0, 0]
      },
      content_2: {
        fontSize: 14,
        alignment: "left",
        margin: [0, 10, 0, 0]
      },
      content_3: {
        fontSize: 14,
        alignment: "right",
        margin: [0, 10, 0, 0]
      },
      content_8: {
        fontSize: 14,
        alignment: "left",
        margin: [20, 10, 0, 0]
      },
      signature: {
        fontSize: 14,
        alignment: "center",
        margin: [0, 30, 0, 0]
      }
    }
  };
  return pdf
}

function getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = error => {
      reject(error);
    };

    img.src = url;
  });
}

export default receipt_2